export type MessageTemplateDraft = {
  channelKind: 'SMS' | 'EMAIL';
  name: string;
  subject: string;
  bodyText: string;
  bodyHtml: string;
};

export function emptyTemplateDraft(kind: 'SMS' | 'EMAIL' = 'SMS'): MessageTemplateDraft {
  return { channelKind: kind, name: '', subject: '', bodyText: '', bodyHtml: '' };
}
